module.exports = __webpack_public_path__ + "static/media/icon1.9d8ef2a5.png";